module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/hoC5Og/tc-custom/9781481426534.jpg?1730520795805",
      "alt": "This image is the cover for the book Sand Dollar Summer"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sand Dollar Summer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Twelve-year-old Lise watches her safe world fall apart when her strong, self-reliant mom is injured in a car accident. To recuperate, Mom takes Lise and her bright little brother to live in a rattletrap house on the beach in Maine for the summer. Although her mother grew up there, this is Lise's first experience with the ocean. She's terrified by what may be lurking in the cold depths and confused by the ways that Maine is changing her mother. "), _c('br'), _c('br'), _vm._v(" As secrets from the past start spilling out, even the solid earth may not keep Lise safe anymore. Lise will have to learn to go with the flow -- or risk falling apart -- in this tender, funny, and wise novel...the story of one family's unforgettable summer.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kimberly K. Jones\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Kimberly K. Jones is the author of Sand Dollar Summer, a Simon & Schuster book.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Margaret K. McElderry Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0